import React from 'react';
import { graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import FeaturedLogos from '../components/FeaturedLogos';
import FeaturedCategories from '../components/FeaturedCategories';
import CompanyReviews from '../components/CompanyReviews';
import FeaturedProducts from '../components/FeaturedProducts';
import ImageCtas from '../components/ImageCtas';
import FeaturedBlogPosts from '../components/FeaturedBlogPosts';
import Faqs from '../components/Faqs';
import IconCtas from '../components/IconCtas';
import ShopInformation from '../components/ShopInformation';

const HomePageTemplate = ({
  data: {
    datoCmsHome: {
      seoMetaTags,
      bannerImage,
      bannerHeading,
      bannerLinks,
      productCategoriesHeading,
      productCategoriesText,
      featuredProductsHeading,
      companyReviewsHeading,
      shopInformationHeading,
      shopInformationText,
      shopInformationImage,
      imageCtas,
      faqsHeading,
      faqs,
      faqsLinkPage,
      featuredBlogsHeading,
    },
    allShopifyProduct: { nodes: featuredProducts },
  },
}) => (
  <Layout isHomepage={true}>
    <HelmetDatoCms seo={seoMetaTags} />
    <main>
      <Banner
        image={bannerImage}
        heading={bannerHeading}
        links={bannerLinks}
        isHomepage={true}
      />
      <FeaturedLogos isHomepage={true} />
      <FeaturedCategories
        heading={productCategoriesHeading}
        text={productCategoriesText}
      />
      <CompanyReviews heading={companyReviewsHeading} />
      <FeaturedProducts
        heading={featuredProductsHeading}
        items={featuredProducts}
      />
      <ImageCtas items={imageCtas} />
      <FeaturedBlogPosts heading={featuredBlogsHeading} />
      <Faqs heading={faqsHeading} items={faqs} link={faqsLinkPage} />
      <IconCtas />
      <ShopInformation
        heading={shopInformationHeading}
        text={shopInformationText}
        image={shopInformationImage}
      />
    </main>
  </Layout>
);

export const HomePageTemplateQuery = graphql`
  query HomePageTemplateQuery($featuredProducts: [String]) {
    datoCmsHome {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      bannerImage {
        gatsbyImageData(width: 1400, height: 600, layout: FULL_WIDTH)
        alt
      }
      bannerHeading
      bannerLinks {
        id
        text
        page {
          ...LinkFragment
        }
      }
      productCategoriesHeading
      productCategoriesText
      ctaStripHeading
      ctaStripText
      ctaStripLink {
        text
        page {
          ...LinkFragment
        }
      }
      featuredProductsHeading
      companyReviewsHeading
      shopInformationHeading
      shopInformationText
      shopInformationImage {
        url
        alt
      }
      imageCtas {
        id
        heading
        text
        image {
          gatsbyImageData(width: 250, height: 400)
          alt
        }
        link {
          text
          page {
            ...LinkFragment
          }
        }
      }
      faqsHeading
      faqs {
        id
        heading
        text
      }
      faqsLinkPage {
        ...LinkFragment
      }
      featuredBlogsHeading
    }
    allShopifyProduct(filter: { handle: { in: $featuredProducts } }) {
      nodes {
        ...ProductCardFragment
      }
    }
  }
`;

export default HomePageTemplate;
